import { Box, Grid, Typography } from "@mui/material";
import Stack from "@mui/material/Stack/Stack";
import { useSelector } from "react-redux";
import {
  EmailOutlined,
  Facebook,
  Instagram,
  Person,
  WhatsApp,
  YouTube,
} from "@mui/icons-material";
import { selectLocation } from "../store/location/selector";
import { useCallback } from "react";

export function FooterPublicRoutes() {
  const location = useSelector(selectLocation);
  const navigate = useCallback((url: string) => {
    const toOpen = window.open(url, "_blank", "noopener,noreferrer");
    if (toOpen) toOpen.opener = null;
  }, []);
  return (
    <Stack
      component="footer"
      className="w-full bg-[#484040] flex flex-row justify-center p-5 text-white font-sans"
      id="contact"
    >
      <Stack direction="column" sx={{ width: { xs: "100%", xl: "1750px" } }}>
        <Box className="flex flex-col md:flex-row md:justify-between gap-5">
          <Box className="flex flex-col gap-2">
            <Box
              component="img"
              src="/assets/icon/ic_binus_footer.png"
              className="w-1/5 mb-2"
            />
            <Typography fontSize={16} className="font-bold">
              Binus Building Management {location?.bmName}
            </Typography>
            <Typography fontSize={12}>{location?.address}</Typography>
            <Typography fontSize={12} className="md:mb-8">
              Phone: {location?.phone} Ext. {location?.ext}
            </Typography>
          </Box>
          <Box className=" flex flex-col md:w-1/3 gap-3">
            <Typography className="font-bold">
              Have other inquiries? Contact our member!
            </Typography>
            <Grid container spacing={4}>
              <Grid item xs={12} md={6} className="flex flex-col gap-2">
                <Box className="flex gap-2 items-center">
                  <Person />
                  <Typography className="text-sm">
                    {location?.manager.position} - {location?.manager.name}
                  </Typography>
                </Box>
                <Box className="flex gap-2 items-center">
                  <WhatsApp />
                  <Typography className="text-sm">
                    +62{location?.manager.phone}
                  </Typography>
                </Box>
              </Grid>
              {location?.personInCharge.map((e, i) => (
                <Grid item xs={12} md={6} className="flex flex-col gap-2">
                  <Box className="flex gap-2 items-center">
                    <Person />
                    <Typography className="text-sm">
                      {e.position} - {e.name}
                    </Typography>
                  </Box>
                  <Box className="flex gap-2 items-center">
                    <WhatsApp />
                    <Typography className="text-sm">+62{e.phone}</Typography>
                  </Box>
                </Grid>
              ))}
            </Grid>
          </Box>
          <Box className="flex flex-col gap-5">
            {((location.instagram !== "" && location.instagram) ||
              (location.facebook !== "" && location.facebook) ||
              (location.youtube !== "" && location.facebook) ||
              (location.tiktok !== "" && location.tiktok)) && (
              <Box className="flex flex-col gap-3">
                <Typography className="font-bold">
                  Follow us on Social Media
                </Typography>
                <Box className="flex gap-3">
                  {location.instagram !== "" && location.instagram && (
                    <Box>
                      <Instagram
                        className="cursor-pointer"
                        onClick={() => navigate(location.instagram!)}
                      />
                    </Box>
                  )}
                  {location.facebook !== "" && location.facebook && (
                    <Facebook
                      className="cursor-pointer"
                      onClick={() => navigate(location.facebook!)}
                    />
                  )}
                  {location.youtube !== "" && location.facebook && (
                    <YouTube
                      className="cursor-pointer"
                      onClick={() => navigate(location.youtube!)}
                    />
                  )}
                  {location.tiktok !== "" && location.tiktok && (
                    <Box
                      className="w-4 h-4 cursor-pointer"
                      onClick={() => navigate(location.tiktok!)}
                    >
                      <img src="/assets/icon/ic_tiktok.svg" alt="TikTok Icon" />
                    </Box>
                  )}
                </Box>
              </Box>
            )}
            <Box className="flex flex-col gap-3">
              <Typography className="text-xs mt-2">
                If you have any enquiries please email us at
              </Typography>
              <Box className="flex gap-2 items-center">
                <EmailOutlined />
                <Typography className="text-xs">{location.email}</Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box className="text-center mt-6 md:mt-3">
          <Typography fontSize={9}>
            This web is managed by BINUS General Affairs Building Management.
            All rights reserved.
          </Typography>
        </Box>
      </Stack>
    </Stack>
  );
}
